import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Api} from '../enum/Api';
import {serviceAuthHeader} from '../constants/service-auth-token';
import {Observable} from 'rxjs';


@Injectable()
export class HttpService {
  constructor(private http: HttpClient) { 
    this.API_HEADERS = this.API_HEADERS.set('Content-Type', 'application/json');
  }

  API_URL: string = environment.api_url;
  BASE_URL: string = environment.base_url;
  ACCOUNT_TOKEN: string = environment['X-Explorer-Account-Token'];

  private API_HEADERS: HttpHeaders = new HttpHeaders();

  setHeaders(api: Api, authorization: boolean, body?: any) {
    if (authorization) {
      if (localStorage.getItem('token')) {
        this.API_HEADERS = this.API_HEADERS.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
          .set('X-Explorer-Account-Token', this.ACCOUNT_TOKEN)
          .delete('X-Explorer-Authentication-Class');
      } else {
        this.API_HEADERS = this.API_HEADERS.set('Authorization', 'Basic ' + body.authorization)
          .set('X-Explorer-Authentication-Class', 'crm.contact')
          .delete('X-Explorer-Account-Token');
      }
    } else if (api === Api.One_Portal) {
      this.API_HEADERS = this.API_HEADERS.set('Authorization', serviceAuthHeader)
        .set('X-Explorer-Account-Token', this.ACCOUNT_TOKEN)
        .delete('X-Explorer-Authentication-Class');
    } else {
      this.API_HEADERS = this.API_HEADERS.set('Authorization', serviceAuthHeader)
        .set('X-Explorer-Account-Token', this.ACCOUNT_TOKEN)
        .delete('X-Explorer-Authentication-Class');
    }
  }

  getUrl(path: string, api: Api): string {
    switch (api) {
      case Api.One_Portal:
        return this.API_URL + path;
      default: throw new Error('Api inválida');
    }
  }


  post(path: string, api: Api, body: object, authorization = false): Observable<any> {
    this.setHeaders(api, authorization, body);
    return this.http.post(this.getUrl(path, api), body, {
      headers: this.API_HEADERS,
    });
  }

  get(path: string, api: Api, authorization = false, body?: any): Observable<any> {
    this.setHeaders(api, authorization, body);
    return this.http.get(this.getUrl(path, api), {
      headers: this.API_HEADERS,
    });
  }
}
